/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationsGetGateway } from "../funcs/organizationsGetGateway.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationGateway } from "../models/components/organizationgateway.js";
import {
  GetOrganizationGatewayRequest,
  GetOrganizationGatewaySecurity,
} from "../models/operations/getorganizationgateway.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationGatewayQueryData = OrganizationGateway;

export function prefetchOrganizationGateway(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetOrganizationGatewayRequest | undefined,
  security?: GetOrganizationGatewaySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationGatewayQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationGatewayQuery(
  client$: GramCore,
  request?: GetOrganizationGatewayRequest | undefined,
  security?: GetOrganizationGatewaySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationGatewayQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationGateway({
      gramSession: request?.gramSession,
    }),
    queryFn: async function organizationGatewayQueryFn(
      ctx,
    ): Promise<OrganizationGatewayQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationsGetGateway(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationGateway(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "organizations", "getGateway", parameters];
}
